import React, {Component} from 'react';
//import Actions from '../../../actions/Actions.js';
import Quantity from './Quantity';
import * as Products from '../../../libraries/Products.js';
import QuantityNoControl from './QuantityNoControl';
import Weight from './Weight';
import './style.css';

class Container extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    //console.log(this.props.item);

    this.is_free = this.props.data.final_price===0;
    this.is_upsell = false;
  };

  

  render() {

    //if( this.is_free ) return null;

    //Upsell no control
    if( typeof window.__config_reactjs_cart.upsells !== "undefined" ){
      if( window.__config_reactjs_cart.upsells.includes(this.props.data.handle) ) this.is_upsell = true;
    }
    //console.log( this.props.data );

    return (
      <React.Fragment>
        {(() => {
        if ( this.is_free || this.is_upsell ) {
          return (
            <QuantityNoControl
              item={this.props.item}
              quantity={this.props.quantity}
              variant_id={this.props.variant_id}
            />
          )
        }
        else{
          if ( window.__discount_object.isPound(this.props.item.handle) ) {
            return (
              <Weight
                item={this.props.item}
                quantity={this.props.quantity}
                variant_id={this.props.variant_id}
              />
            )
          }
          else{
            return (
              <Quantity
                item={this.props.item}
                quantity={this.props.quantity}
                variant_id={this.props.variant_id}
                product_config={Products.getConfig(this.props.item)}
              />
            )
          }
        }
        })()}

        
        
      </React.Fragment>
    )
  };
}
export default Container;